export const en = {
    campaign_broad_match_goal_all: 'Optimizing conversion rate for all goals',
    campaign_broad_match_goal_changed: 'Optimizing conversion rate {oldGoal} {newGoal}',
    campaign_broad_match_goal_id: 'Optimizing conversion rate for goal "{goalName}"',
    campaign_broad_match_limit: 'Maximum expenditure is {limit}% from total campaign expenditures',
    campaign_broad_match_limit_changed: 'Maximum expenditure is {oldLimit} {newLimit} from total campaign expenditures',
    'on-all-goals': 'all goals',
    'on-goal': 'for goal "{goalName}"'
};
